(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  // Héroe spotlight: el foco sigue al cursor y la foto se inclina un poco
  function initHero(root) {
    (root || document).querySelectorAll('[data-mt-hero]').forEach(function (hero) {
      if (hero.dataset.mtInit) return; hero.dataset.mtInit = '1';
      if (reduce || window.matchMedia('(hover: none)').matches) return;
      var wrap = hero.closest('.shopify-section') || hero;
      var media = hero.querySelector('.mt-hero__media');
      var tilt = parseFloat(hero.dataset.tilt || '6');
      wrap.addEventListener('mousemove', function (ev) {
        var r = wrap.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width, y = (ev.clientY - r.top) / r.height;
        hero.style.setProperty('--mt-x', (x * 100).toFixed(1) + '%');
        hero.style.setProperty('--mt-y', (y * 100).toFixed(1) + '%');
        if (media) {
          media.style.setProperty('--mt-ry', ((x - 0.5) * tilt).toFixed(2) + 'deg');
          media.style.setProperty('--mt-rx', ((0.5 - y) * tilt).toFixed(2) + 'deg');
        }
      });
      wrap.addEventListener('mouseleave', function () {
        if (media) { media.style.setProperty('--mt-ry', '0deg'); media.style.setProperty('--mt-rx', '0deg'); }
      });
    });
  }

  // Hotspots: punto y elemento de la lista sincronizados
  function initHotspots(root) {
    (root || document).querySelectorAll('[data-mt-hotspots]').forEach(function (box) {
      if (box.dataset.mtInit) return; box.dataset.mtInit = '1';
      var items = box.querySelectorAll('[data-mt-hs]');
      function activar(i) {
        items.forEach(function (el) { el.classList.toggle('is-activo', el.dataset.mtHs === i); });
      }
      items.forEach(function (el) {
        el.addEventListener('click', function () { activar(el.dataset.mtHs); });
        el.addEventListener('mouseenter', function () { if (el.classList.contains('mt-hs__punto')) activar(el.dataset.mtHs); });
      });
      activar('1');
    });
  }

  // Selector de escenario
  function initEscenarios(root) {
    (root || document).querySelectorAll('[data-mt-escenarios]').forEach(function (box) {
      if (box.dataset.mtInit) return; box.dataset.mtInit = '1';
      var tabs = box.querySelectorAll('.mt-esc__tab');
      var escenas = box.querySelectorAll('.mt-esc__escena');
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t, j) { t.classList.toggle('is-activo', i === j); t.setAttribute('aria-selected', i === j); });
          escenas.forEach(function (e, j) { e.classList.toggle('is-activo', i === j); });
        });
      });
    });
  }

  // FAQ
  function initFaq(root) {
    (root || document).querySelectorAll('[data-mt-faq]').forEach(function (box) {
      if (box.dataset.mtInit) return; box.dataset.mtInit = '1';
      box.querySelectorAll('.mt-faq__item').forEach(function (item) {
        var q = item.querySelector('.mt-faq__q');
        q.addEventListener('click', function () {
          var abierto = item.classList.toggle('is-abierto');
          q.setAttribute('aria-expanded', abierto);
        });
      });
    });
  }

  // Variantes: tarjeta de compra (select) y página de producto (chips + galería)
  function money(cents, formato) {
    var v = (cents / 100).toFixed(2);
    var conComa = v.replace('.', ',');
    return (formato || '${{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, v);
  }

  function initVariantes(root) {
    (root || document).querySelectorAll('[data-mt-variantes]').forEach(function (box) {
      if (box.dataset.mtInit) return; box.dataset.mtInit = '1';
      var dataEl = box.querySelector('script[type="application/json"]');
      if (!dataEl) return;
      var variantes = JSON.parse(dataEl.textContent);
      var formato = box.dataset.moneyFormat;
      var input = box.querySelector('input[name="id"]');
      var precio = box.querySelector('[data-mt-precio]');
      var tachado = box.querySelector('[data-mt-tachado]');
      var boton = box.querySelector('[data-mt-boton]');
      var textoBoton = boton ? boton.dataset.texto : '';
      var textoAgotado = boton ? boton.dataset.agotado : '';

      function aplicar(v) {
        if (!v) return;
        if (input) input.value = v.id;
        if (precio) precio.textContent = money(v.price, formato);
        if (tachado) {
          var hay = v.compare_at_price && v.compare_at_price > v.price;
          tachado.textContent = hay ? money(v.compare_at_price, formato) : '';
          tachado.hidden = !hay;
        }
        if (boton) { boton.disabled = !v.available; boton.firstChild.textContent = v.available ? textoBoton : textoAgotado; }
        var media = v.featured_media;
        if (media && media.id) {
          var mini = box.querySelector('[data-media-id="' + media.id + '"]');
          if (mini) mini.click();
          // Tarjeta de compra de la portada: su foto cambia al modelo elegido
          var card = box.closest('.mt-compra__card');
          var foto = card && card.querySelector('[data-mt-foto-variante]');
          if (foto && media.preview_image && media.preview_image.src) {
            var src = media.preview_image.src;
            foto.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1000';
            foto.srcset = '';
            foto.style.objectFit = 'contain';
            foto.style.background = '#fff';
          }
        }
      }

      var select = box.querySelector('select[data-mt-select]');
      if (select) {
        select.addEventListener('change', function () {
          aplicar(variantes.find(function (v) { return String(v.id) === select.value; }));
        });
      }
      box.querySelectorAll('[data-mt-opcion]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          var elegidas = [];
          box.querySelectorAll('[data-mt-grupo]').forEach(function (g) {
            var c = g.querySelector('input:checked');
            elegidas.push(c ? c.value : null);
          });
          aplicar(variantes.find(function (v) {
            return v.options.every(function (o, i) { return o === elegidas[i]; });
          }));
        });
      });
    });
  }

  function initGaleria(root) {
    (root || document).querySelectorAll('[data-mt-galeria]').forEach(function (box) {
      if (box.dataset.mtInit) return; box.dataset.mtInit = '1';
      var principal = box.querySelector('.mt-prod__principal img');
      box.querySelectorAll('.mt-prod__mini').forEach(function (mini) {
        mini.addEventListener('click', function () {
          box.querySelectorAll('.mt-prod__mini').forEach(function (m) { m.classList.remove('is-activo'); });
          mini.classList.add('is-activo');
          if (principal) { principal.src = mini.dataset.src; principal.srcset = ''; }
        });
      });
    });
  }

  function initTodo(ev) {
    var root = ev && ev.target && ev.target.querySelectorAll ? ev.target : document;
    initReveal(root); initHero(root); initHotspots(root); initEscenarios(root);
    initFaq(root); initGaleria(root); initVariantes(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
